import {Component, OnDestroy, OnInit} from "@angular/core";
import {StatusListener} from "../../../status-listener";
import { AppStatus, getCurrency } from "../../../@models/app-status";
import {Credit} from "../../../../shared-gen/Model/Financial/Credit";
import {OrderItem} from "../../../../shared-gen/Model/Orders/OrderItem";
import {AppService} from "../../../services/app.service";
import { Currency } from "../../../../shared-gen/Model/Utils/Currency";


@Component({
	selector: "kkb-tur-payment-panel",
	templateUrl: "./tur-payment-panel.component.html",
	styleUrls: ["./tur-payment-panel.component.scss", "../../../pages/tur/tur.scss"]
})
export class TurPaymentPanelComponent extends StatusListener implements OnInit, OnDestroy {

	price: number = 0;
	discount: number = 0;
	cash: number = 0;
	toPay: number = 0;
	isChangeLow = false;

	credit: Credit;
	cart: OrderItem[] = [];

	currency = Currency.EUR;

	warnings: Warning[] = [];
	saniFairMinPrice = 0;

	sanifairState = true;
	qrState = true;
	hardcashState = true;
	cashlessState = true;

	sanifairVisible: Visibility = "";
	voucherVisible: Visibility = "";
	cashVisible: Visibility = "";
	cashlessVisible: Visibility = "";
	popupTimeout;

	showPayButton: boolean = true;


	constructor(app: AppService) {
		super(app);
	}

	onStatusChanged(status: AppStatus) {
		super.onStatusChanged(status);
		this.currency = getCurrency(status);

		const payment = status.deviceStatus.PaymentStatus;
		this.credit = payment.Credit;
		// Change low?
		this.isChangeLow = payment.IsChangeLow;
		// Update allowed payment methods
		const accepted = payment.AcceptedPayments;
		this.sanifairState = accepted.SaniFair;
		this.qrState = accepted.QR;
		this.hardcashState = accepted.Coins.length > 0 || accepted.Bills.length > 0;
		this.cashlessState = accepted.Cashless;

		const vending = status.deviceStatus.VendingStatus;
		this.cart = vending.Cart.Items;
		if (vending.Order) {
			this.cart = vending.Order.Items;
		}

		this.showPayButton = vending.VmcState !== "Paying";

		let price = 0;
		this.cart.forEach(it => price += it.Price + it.Deposit);
		this.price = price / 100;

		this.toPay = payment.PaymentPlan.MissingCents / 100;

		if (this.credit) {
			this.discount = this.credit.VoucherCents / 100;
			this.cash = this.credit.HardCashCents / 100;
		}

		let warnings: Warning[] = [];
		if (payment.IsChangeLow)
			warnings.push("ChangeLow");
		if (payment.Credit.Voucher != null && payment.Credit.Voucher.Class == "SaniFair" &&
			payment.EligiblePayments.SaniFair == "MinOrderPrice")
			warnings.push("SaniFairMinCents");
		this.warnings = warnings;
		this.saniFairMinPrice = payment.EligiblePayments.SaniFairMinCents / 100;
	}

	toggleSanifairPopup() {
		clearTimeout(this.popupTimeout);
		this.sanifairVisible = this.togglePopup(this.sanifairVisible);

		//Hide hide after 5 seconds
		if (this.sanifairVisible) {
			this.popupTimeout = setTimeout(() => {
				this.sanifairVisible = "";
			}, 5000);
		}
	}

	toggleVoucherPopup() {
		clearTimeout(this.popupTimeout);
		this.voucherVisible = this.togglePopup(this.voucherVisible);

		//Hide hide after 5 seconds
		if (this.isPopupVisible(this.voucherVisible)) {
			this.popupTimeout = setTimeout(() => {
				this.voucherVisible = "";
			}, 5000);
		}
	}


	toggleCashPopup() {
		clearTimeout(this.popupTimeout);
		this.cashVisible = this.togglePopup(this.cashVisible);

		//Hide hide after 5 seconds
		if (this.isPopupVisible(this.cashVisible)) {
			this.popupTimeout = setTimeout(() => {
				this.cashVisible = "";
			}, 5000);
		}
	}

	toggleCashlessPopup() {
		clearTimeout(this.popupTimeout);
		this.cashlessVisible = this.togglePopup(this.cashlessVisible);

		//Hide hide after 5 seconds
		if (this.isPopupVisible(this.cashlessVisible)) {
			this.popupTimeout = setTimeout(() => {
				this.cashlessVisible = "";
			}, 5000);
		}
	}

	private isPopupVisible(popup) {
		return popup === "popupVisible";
	}


	private togglePopup(now: Visibility): Visibility {
		return now === "popupVisible" ? "" : "popupVisible";
	}

	async pay() {
		await this.app.api.orderApi.orderCart();
	}
}

type Visibility = "" | "popupVisible";
type Warning = "ChangeLow" | "SaniFairMinCents";
